import React from 'react'
import { connect } from 'react-redux'
import { authorizeUser } from 'actions/Auth'
import { tokenNearExpiry, checkAuthentication } from './checkAuthentication'
import debug from 'debug'

// Num seconds a locally stored token can be away from token expiry,
// before is illegible for a preemptive refresh.
//
// Of course, this should be smaller than token lifetime in seconds, or else
// we will keep refreshing again and again.
const tokenGracePeriodSeconds = 300

// Num seconds between local token is checked if it needs preemptive refreshing.
// This can be quite often, as it does nothing if expiry has not been reached yet.
// Should be often enough, that a hibernated browser that wakes up has change of
// detecting a dead token and refreshing it.
const tokenExpiryCheckIntervalSeconds = 10

const authDebug = debug('linkgua:auth:checks')

class PreemptiveSessionRefresher extends React.Component {

  timerId = null

  componentWillUnmount () {
    this.clearTimer()
  }

  clearTimer = () => {
    if (this.timerId != null) {
      authDebug('stopping timer watch of token expire %d', this.timerId)
      clearInterval(this.timerId)
      this.timerId = null
    }
  }

  startTimer = (authorizeUser, authUser) => {
    this.clearTimer()
    this.timerId = setInterval(() => this.checkAndPossiblyInitiatePreemptiveRefresh(authorizeUser, authUser), tokenExpiryCheckIntervalSeconds * 1000)
    authDebug('timer started watching token expire %d', this.timerId)
  }

  checkAndPossiblyInitiatePreemptiveRefresh = (authorizeUser, authUser) => {
    if (tokenNearExpiry(tokenGracePeriodSeconds, authUser)) {
      authDebug('token is near expiry - initiating background refresh')
      authorizeUser()
    } else {
      authDebug('token not near expiry yet - noop')
    }
  }

  render = () => {
    this.clearTimer()

    const { authUser, authorizeUser } = this.props

    if (authUser) {
      if (checkAuthentication(authUser)) {
        // only if we have a token, which is also currently valid, will we start a timer to refresh it
        this.startTimer(authorizeUser, authUser)
      } else {
        authDebug('NOT starting session refresher on an expired token')
      }
    }

    return null
  }
}

const mapStateToProps = ({auth: {authUser}}) => {
  return {authUser}
}

const mapDispatchToProps = {authorizeUser}

PreemptiveSessionRefresher = connect(mapStateToProps, mapDispatchToProps)(PreemptiveSessionRefresher)

export default PreemptiveSessionRefresher



// WEBPACK FOOTER //
// ./util/PreemptiveSessionRefresher.js